// Apparition sobre au scroll des éléments [data-mp-reveal]. Désactivée si l'utilisateur réduit les animations.
(() => {
  // La classe .mp-js est posée dans <head> (layout/theme.liquid) pour éviter tout flash au chargement.
  if (!document.documentElement.classList.contains('mp-js')) return;

  const observer = new IntersectionObserver(
    (entrees) => {
      entrees.forEach((entree) => {
        if (!entree.isIntersecting) return;
        entree.target.classList.add('is-visible');
        observer.unobserve(entree.target);
      });
    },
    { rootMargin: '0px 0px -10% 0px' }
  );

  const observerTout = (racine = document) => {
    racine.querySelectorAll('[data-mp-reveal]:not(.is-visible)').forEach((el) => observer.observe(el));
  };

  observerTout();
  // Sections ajoutées ou rechargées dans l'éditeur de thème
  document.addEventListener('shopify:section:load', (event) => observerTout(event.target));
})();
